(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Specialty', Specialty);

    Specialty.$inject = ['$resource'];

    function Specialty ($resource) {
        var resourceUrl =  'api/specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
